var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-data-table',{attrs:{"p-headers":_vm.headers,"p-title":"Grade","p-read-link":"grid.read.one","p-create-link":"grid.create","p-name":"grids"}})}
var staticRenderFns = []

export { render, staticRenderFns }